module.exports = __webpack_public_path__ + "static/media/digital-dashboard.c405d0f7.svg";